import httpService from '../../utils/httpService';
import authen from '../../utils/authen';

function unwrap (res) {
  if (res == null) return null;
  if (typeof res === 'string') {
    try { return JSON.parse(res); } catch (e) { return null; }
  }
  if (res.data !== undefined && res.ok === undefined) return res.data;
  return res;
}

function post (path, payload) {
  return httpService.methods.$post(`Uc300API/${path}`, JSON.stringify(Object.assign({
    tokenkey: authen.getToken()
  }, payload || {}))).then(unwrap);
}

export default {
  namespaced: true,
  state: {
    devices: [],
    capability: null,
    selected: null,
    latest: null,
    rawMessages: [],
    deadLetters: [],
    loading: false
  },
  getters: {
    devices: state => state.devices,
    capability: state => state.capability,
    selected: state => state.selected,
    latest: state => state.latest,
    rawMessages: state => state.rawMessages,
    deadLetters: state => state.deadLetters,
    loading: state => state.loading
  },
  mutations: {
    SET_LOADING (state, value) { state.loading = value; },
    SET_DEVICES (state, value) { state.devices = value || []; },
    SET_CAPABILITY (state, value) { state.capability = value || null; },
    SET_SELECTED (state, value) { state.selected = value || null; },
    SET_LATEST (state, value) { state.latest = value || null; },
    SET_RAW (state, value) { state.rawMessages = value || []; },
    SET_DEAD (state, value) { state.deadLetters = value || []; }
  },
  actions: {
    FETCH_CAPABILITIES ({ commit }) {
      return post('Capabilities').then(data => {
        if (data && data.ok) commit('SET_CAPABILITY', data.capability);
        return data;
      });
    },
    FETCH_DEVICES ({ commit }) {
      commit('SET_LOADING', true);
      return post('List').then(data => {
        if (data && data.ok) commit('SET_DEVICES', data.devices);
        return data;
      }).finally(() => commit('SET_LOADING', false));
    },
    CREATE_DEVICE (_, profile) {
      return post('Create', { profile, ownerUsername: authen.get('qlmn_username') });
    },
    SAVE_DEVICE (_, profile) {
      return post('Save', { profile });
    },
    DELETE_DEVICE (_, payload) {
      return post('Delete', payload);
    },
    PREVIEW_FORMULA (_, payload) {
      return post('PreviewFormula', payload);
    },
    FETCH_DEVICE ({ commit }, deviceId) {
      return post('Get', { deviceId }).then(data => {
        if (data && data.ok) commit('SET_SELECTED', data);
        return data;
      });
    },
    FETCH_LATEST ({ commit }, deviceId) {
      return post('Latest', { deviceId }).then(data => {
        if (data && data.ok) commit('SET_LATEST', data.telemetry);
        return data;
      });
    },
    FETCH_HISTORY (_, payload) {
      return post('History', payload);
    },
    FETCH_RAW ({ commit }, payload) {
      return post('RawMessages', payload).then(data => {
        if (data && data.ok) commit('SET_RAW', data.messages);
        return data;
      });
    },
    FETCH_DEAD ({ commit }, payload) {
      return post('DeadLetters', payload).then(data => {
        if (data && data.ok) commit('SET_DEAD', data.messages);
        return data;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/uc300.js